import React from "react";
import { T } from "../theme";

// The one "+ Add …" affordance, used everywhere a list can grow: Progress
// steps, block sessions, ledger line items and one-offs, upcoming items.
export default function AddRowButton({ label, onClick, rounded }) {
  return (
    <button onClick={onClick} style={{ width: "100%", padding: "12px 20px", fontSize: 12, fontWeight: 600, color: T.fgMuted, background: "transparent", border: "none", borderTop: `1px dashed ${T.borderSubtle}`, cursor: "pointer", fontFamily: T.fontSans, textAlign: "left", borderRadius: rounded ? `0 0 ${T.radiusMd} ${T.radiusMd}` : 0 }}>{label}</button>
  );
}
